/**
 * Runtime configuration loader
 * Loads configuration from window._env_ (set by config.js)
 * Falls back to process.env only if window._env_ is not available
 */

interface RuntimeConfig {
  REACT_APP_BACKEND_URL: string;
  REACT_APP_SAAED_API_BASE_URL: string;
  REACT_APP_SAAED_ESERVICES_PATH: string;
  REACT_APP_SAAED_ADMIN_PATH: string;
  REACT_APP_NOMINATIM_API_URL: string;
}

// Extend Window interface for TypeScript
declare global {
  interface Window {
    _env_?: RuntimeConfig;
  }
}

/**
 * Get configuration from window._env_ or fallback to process.env
 */
function getConfig(): RuntimeConfig {
  // Try to use window._env_ from config.js (runtime)
  if (window._env_ && window._env_.REACT_APP_BACKEND_URL) {
    console.log('📝 [CONFIG] Loading from config.js (runtime)');
    return window._env_;
  }
  // Fallback: Hardcoded config for production backend
  console.warn('⚠️ [CONFIG] config.js not found or missing backend URL, using hardcoded values');
  return {
    REACT_APP_BACKEND_URL: 'https://saaedi-api.softecinternational.com',
    REACT_APP_SAAED_API_BASE_URL: 'https://saaed360test.saaed.ae',
    REACT_APP_SAAED_ESERVICES_PATH: '/EServices/api/objection',
    REACT_APP_SAAED_ADMIN_PATH: '/AdminPages/api/Objection',
    REACT_APP_NOMINATIM_API_URL: 'https://nominatim.openstreetmap.org'
  };
}

// Export the config object
export const config = getConfig();

// Log loaded configuration (without sensitive data)
console.log('✅ [CONFIG] Configuration loaded:', {
  BACKEND_URL: config.REACT_APP_BACKEND_URL ? '✓ Set' : '✗ Missing',
  SAAED_API: config.REACT_APP_SAAED_API_BASE_URL ? '✓ Set' : '✗ Missing',
  NOMINATIM_API: config.REACT_APP_NOMINATIM_API_URL ? '✓ Set' : '✗ Missing'
});

